import { ServiceInvoiceMatrixBase } from './service-invoice-matrix-base';
import { I18N } from 'aurelia-i18n';
import { autoinject, bindable } from 'aurelia-framework';
import { ErpSystemService, ServiceWasteProductMatrixService } from 'services';
import { ToastService } from 'services/toast-service';
import { ErrorService } from 'services/error-service';
import { ServiceKiloWasteProductService } from 'services/service-kilo-waste-product-service';
import { ServiceKiloWasteProduct } from 'models';
import { ServiceCubicWasteProduct } from 'models/ServiceCubicWasteProduct';
import { ServiceCubicWasteProductService } from 'services/service-cubic-waste-product-service';
import { getAutocompleteTypeFromProductSource } from 'elements/input-autocomplete-type';

@autoinject
export class WasteMatrixView extends ServiceInvoiceMatrixBase {
  @bindable
  protected erpSystemId: number;
  
  protected inputAutocompleteType: string = 'generalproduct';

  private kiloWasteProduct: ServiceKiloWasteProduct = new ServiceKiloWasteProduct();
  private cubicWasteProduct: ServiceCubicWasteProduct = new ServiceCubicWasteProduct();

  constructor(
    t: I18N,
    matrixService: ServiceWasteProductMatrixService,
    toaster: ToastService,
    errorService: ErrorService,
    erpSystemService: ErpSystemService,
    private kiloWasteService: ServiceKiloWasteProductService,
    private cubicWasteService: ServiceCubicWasteProductService
  ) {
    super(t, matrixService, toaster, errorService, erpSystemService);
    this.setErpSystemId(this.erpSystemId);
  }

  public attached() {
    super.attached();
    this.setLocalErpSystem(this.erpSystemId);
    void this.getKiloWasteProducts();
    void this.getCubicWasteProducts();
  }

  public async getKiloWasteProducts() {
    const products = await this.kiloWasteService.get((`?$filter=Product/ProductSource eq ${this.erpSystemId} and Deleted eq null`)) as unknown as ServiceKiloWasteProduct[];

    if(products.length > 0) {
      this.kiloWasteProduct = products[0];
    } else {
      this.kiloWasteProduct = new ServiceKiloWasteProduct();
    }
  }

  public async getCubicWasteProducts() {
    const products = await this.cubicWasteService.get((`?$filter=Product/ProductSource eq ${this.erpSystemId} and Deleted eq null`)) as unknown as ServiceCubicWasteProduct[];

    if(products.length > 0) {
      this.cubicWasteProduct = products[0];
    } else {
      this.cubicWasteProduct = new ServiceCubicWasteProduct();
    }
  }

  public async onSelectedKiloWasteProduct(productId: number) {
    try {
      this.kiloWasteProduct.ProductId = productId;
      await this.kiloWasteService.post(this.kiloWasteProduct);
      await this.getKiloWasteProducts();
      this.toaster.showSuccess(this.t.tr('general.saved'));
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  public async deleteKiloWasteProduct() {
    try {
      await this.kiloWasteService.delete(this.kiloWasteProduct.Id);
      await this.getKiloWasteProducts();
      this.toaster.showSuccess(this.t.tr('general.deleted'));
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  public async onSelectedCubicWasteProduct(productId: number) {
    try {
      this.cubicWasteProduct.ProductId = productId;
      await this.cubicWasteService.post(this.cubicWasteProduct);
      await this.getCubicWasteProducts();
      this.toaster.showSuccess(this.t.tr('general.saved'));
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  public async deleteCubicWasteProduct() {
    try {
      await this.cubicWasteService.delete(this.cubicWasteProduct.Id);
      await this.getCubicWasteProducts();
      this.toaster.showSuccess(this.t.tr('general.deleted'));
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected setLocalErpSystem(erpSystemProductSource: number) {
    this.inputAutocompleteType = getAutocompleteTypeFromProductSource(erpSystemProductSource);
  }
}
